import { APPOINTMENT, HOUSE_CALL, LAB_REPORT } from 'Constants/service-types';
import style from 'Containers/Notification/List/NotificationList.less';
import ServiceAppointment from 'Assets/images/service_appointment.svg';
import ServiceConsult from 'Assets/images/service_consult.svg';
import ServiceTest from 'Assets/images/service_test.svg';
import { string } from 'prop-types';
import React from 'react';

const NotiServiceIcon = ({ type }) => {
  if (type === APPOINTMENT)
    return <img alt={type} className={style.ServiceImage} src={ServiceAppointment} />;
  if (type === HOUSE_CALL)
    return <img alt={type} className={style.ServiceImage} src={ServiceConsult} />;
  if (type === LAB_REPORT)
    return <img alt={type} className={style.ServiceImage} src={ServiceTest} />;
  return null;
};

NotiServiceIcon.propTypes = {
  type: string.isRequired,
};

export default NotiServiceIcon;
